import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d99e5f98"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "about-item public-cases"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "buttons-wrapper btn-m"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-message-circle" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "request-msg"
}
const _hoisted_6 = { class: "about" }
const _hoisted_7 = {
  key: 0,
  class: "about-item"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "about__title" }, /*#__PURE__*/_toDisplayString('Subscription Info'), -1))
const _hoisted_9 = { class: "about__text" }
const _hoisted_10 = { class: "about__text" }
const _hoisted_11 = { class: "about__text" }
const _hoisted_12 = {
  key: 1,
  class: "about-item"
}
const _hoisted_13 = { class: "about__title" }
const _hoisted_14 = { class: "about__text" }
const _hoisted_15 = {
  key: 2,
  class: "about-item"
}
const _hoisted_16 = { class: "about__title" }
const _hoisted_17 = { class: "about__text" }
const _hoisted_18 = { class: "about__text" }
const _hoisted_19 = { class: "about__text" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 3,
  class: "about-item"
}
const _hoisted_24 = { class: "about__title" }
const _hoisted_25 = { class: "about__text" }
const _hoisted_26 = { class: "about__text" }
const _hoisted_27 = { class: "about__text" }
const _hoisted_28 = {
  key: 4,
  class: "about-item"
}
const _hoisted_29 = { class: "about__title" }
const _hoisted_30 = {
  key: 0,
  class: "about__text"
}
const _hoisted_31 = {
  key: 1,
  class: "about__text"
}
const _hoisted_32 = { class: "about__text" }
const _hoisted_33 = { class: "about__text" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = {
  key: 5,
  class: "about-item"
}
const _hoisted_38 = { class: "about__title" }
const _hoisted_39 = { class: "upload-number" }
const _hoisted_40 = { class: "about__text upload-spacer" }
const _hoisted_41 = { class: "about__text" }
const _hoisted_42 = { class: "upload-number" }
const _hoisted_43 = { class: "about__text upload-spacer" }
const _hoisted_44 = { class: "about__text" }
const _hoisted_45 = { class: "upload-number" }
const _hoisted_46 = { class: "about__text upload-spacer" }
const _hoisted_47 = { class: "about__text" }
const _hoisted_48 = {
  key: 0,
  class: "upload-number"
}
const _hoisted_49 = { class: "about__text upload-spacer" }
const _hoisted_50 = { class: "about__text" }
const _hoisted_51 = {
  key: 1,
  class: "upload-number"
}
const _hoisted_52 = { class: "about__text upload-spacer" }
const _hoisted_53 = { class: "about__text" }
const _hoisted_54 = { class: "upload-number" }
const _hoisted_55 = { class: "about__text upload-spacer" }
const _hoisted_56 = { class: "about__text" }
const _hoisted_57 = { class: "upload-number" }
const _hoisted_58 = { class: "about__text upload-spacer" }
const _hoisted_59 = { class: "about__text" }
const _hoisted_60 = { class: "upload-number" }
const _hoisted_61 = { class: "about__text upload-spacer" }
const _hoisted_62 = { class: "about__text" }
const _hoisted_63 = {
  key: 2,
  class: "upload-number"
}
const _hoisted_64 = { class: "about__text upload-spacer" }
const _hoisted_65 = {
  key: 3,
  class: "upload-number"
}
const _hoisted_66 = { class: "about__text upload-spacer" }
const _hoisted_67 = { class: "upload-number" }
const _hoisted_68 = { class: "about__text upload-spacer" }
const _hoisted_69 = { class: "about__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_public_items = _resolveComponent("drive-public-items")!
  const _component_profile_bottom_pop_up = _resolveComponent("profile-bottom-pop-up")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.driveStore.userPublicCases)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.isPublicCases)
            ? (_openBlock(), _createBlock(_component_drive_public_items, {
                key: 0,
                title: "Public cases",
                isUserPublicItems: true,
                cases: _ctx.driveStore.userPublicCases.data,
                lastPage: _ctx.driveStore.userPublicCases.lastPage,
                skeleton: _ctx.driveStore.dataLoading.userPublicCases
              }, null, 8, ["cases", "lastPage", "skeleton"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMyProfile)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
        : (!_ctx.myProfileById)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!_ctx.disableButton && !_ctx.isDeleted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn primary-btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.messagePerson(_ctx.profileId)))
                    }, [
                      _hoisted_4,
                      _createTextVNode(_toDisplayString(_ctx.$localize('foreign.profile.message.button')), 1)
                    ]),
                    _createElementVNode("span", {
                      class: "icon icon-dots",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.showPopUp = true; _ctx.getPos($event)})
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$localize('foreign.profile.waiting.outcoming.request')), 1))
            ], 64))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.isMyProfile && !_ctx.isPremium)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, "Soft limit: " + _toDisplayString(_ctx.mainStore.subscriptionQuota.filesQuota.maxSoft), 1),
            _createElementVNode("p", _hoisted_10, "Hard limit: " + _toDisplayString(_ctx.mainStore.subscriptionQuota.filesQuota.maxHard), 1),
            _createElementVNode("p", _hoisted_11, "Files uploaded: " + _toDisplayString(_ctx.mainStore.subscriptionQuota.filesQuota.current), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.profile.handle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.$localize('profile.info.handle')), 1),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.profile.handle), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasWorkplace)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$localize('profile.info.workplace')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.workplaces, (workplace, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(workplace.name), 1),
                _createElementVNode("p", _hoisted_18, _toDisplayString(workplace.street), 1),
                _createElementVNode("p", _hoisted_19, [
                  (workplace.city)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(workplace.city) + ",", 1))
                    : _createCommentVNode("", true),
                  (workplace.state)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(workplace.state) + ",", 1))
                    : _createCommentVNode("", true),
                  (workplace.zipCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(workplace.zipCode), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasEducation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.$localize('profile.info.education')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.educations, (education, idx) => {
              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                _createElementVNode("p", _hoisted_25, _toDisplayString(education.school), 1),
                _createElementVNode("p", _hoisted_26, _toDisplayString(education.degree), 1),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.dateFormatter(education.startDate)) + " - " + _toDisplayString(_ctx.dateFormatter(education.endDate)), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasContact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.$localize('profile.info.contact')), 1),
            (_ctx.isMyProfile)
              ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.profile.phone), 1))
              : _createCommentVNode("", true),
            (_ctx.isMyProfile)
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.profile.email), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.profile.street), 1),
            _createElementVNode("p", _hoisted_33, [
              (_ctx.profile.city)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.profile.city) + ",", 1))
                : _createCommentVNode("", true),
              (_ctx.profile.state)
                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.profile.state) + ",", 1))
                : _createCommentVNode("", true),
              (_ctx.profile.zipCode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.profile.zipCode), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMyProfile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("h4", _hoisted_38, _toDisplayString(_ctx.$localize('profile.info.uploaded.header')), 1),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$localize('profile.info.public.cases.uploaded')), 1),
              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.publicCasesAmount), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$localize('profile.info.pictures.uploaded')), 1),
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.photosUploaded), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$localize('profile.info.cases.uploaded')), 1),
              _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.casesCreated), 1)
            ]),
            (!_ctx.myCountry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$localize('profile.info.state')), 1),
                  _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.myState), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.myState)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$localize('profile.info.country')), 1),
                  _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.myCountry), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$localize('profile.info.phone')), 1),
              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.myPhone), 1)
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.$localize('profile.info.profession')), 1),
              _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.myProfession), 1)
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.$localize('profile.info.specialty')), 1),
              _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.mySpecialty), 1)
            ]),
            (_ctx.isStudent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.$localize('profile.info.student')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isResident)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.$localize('profile.info.resident')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.$localize('profile.info.graduation.date')), 1),
              _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.graduationDate), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
      (_ctx.showPopUp)
        ? (_openBlock(), _createBlock(_component_profile_bottom_pop_up, {
            key: 0,
            onHidePopUp: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPopUp = false)),
            positionData: _ctx.positionData
          }, null, 8, ["positionData"]))
        : _createCommentVNode("", true)
    ]))
  ]))
}